import Ellipsis from 'ftellipsis'
export default class CarwowReadMore extends HTMLElement {
  connectedCallback () {
    if (this.querySelector('[data-reader-unique-id]')) {
      // Page is in reader mode, no need to initialise
      return
    }

    this.elToCrop = this.querySelector('[data-text-to-shave]')
    this.isOverflowing = this.contentIsOverflowing()
    this.ellipsis = new Ellipsis(this.elToCrop)
    this.originalHeight = this.calculateOriginalHeight()

    this.setToOriginalHeight()
    this.setFallbacks()
    this.calculateEllipsis()
    this.setupButtton()
    this.checkSpecificHeightNeeded()
  }

  setFallbacks () {
    if (!this.hasAttribute('read-more-text')) {
      this.setAttribute('read-more-text', '')
    }

    if (!this.hasAttribute('read-less-text')) {
      this.setAttribute('read-less-text', '')
    }
  }

  setupButtton () {
    const readMoreButton = this.querySelector('[data-read-more-button]')

    if (!this.isOverflowing) {
      readMoreButton.style.display = 'none'
      return
    }

    readMoreButton.addEventListener('click', e => {
      this.toggleButtonText(e)
      this.toggleCropping()
    })
  }

  checkSpecificHeightNeeded () {
    if (!this.isOverflowing) {
      this.elToCrop.style.height = 'auto'
    }
  }

  contentIsOverflowing () {
    return this.elToCrop.offsetHeight < this.elToCrop.scrollHeight
  }

  toggleButtonText (e) {
    if (e.target.textContent === this.readLessText) {
      e.target.textContent = this.readMoreText
    } else if (!this.readLessText) {
      e.target.remove()
    } else {
      e.target.textContent = this.readLessText
    }
  }

  toggleCropping () {
    if (this.ellipsis.child && this.ellipsis.child.clampedLines) {
      this.ellipsis.unset()
      this.elToCrop.style.height = 'auto'
    } else {
      this.setToOriginalHeight()
      this.calculateEllipsis()
    }
  }

  calculateEllipsis () {
    this.ellipsis.calc()
    this.ellipsis.set()
  }

  setToOriginalHeight () {
    this.elToCrop.style.height = this.originalHeight
  }

  clampIsNotUsed () {
    return this.ellipsis.child && !this.ellipsis.child.clampedLines
  }

  calculateOriginalHeight () {
    return window.getComputedStyle(this.elToCrop).height
  }

  get readMoreText () {
    return this.getAttribute('read-more-text')
  }

  get readLessText () {
    return this.getAttribute('read-less-text')
  }
}

window.addEventListener('DOMContentLoaded', () => {
  if (window.customElements.get('carwow-read-more')) { return }
  window.customElements.define('carwow-read-more', CarwowReadMore)
})
